module.exports = __webpack_public_path__ + "static/media/card-slash.0e8a312e.svg";